module.exports = __webpack_public_path__ + "7577a676050f2d1cb292c0e11b826a64.svg";